export default "__VITE_ASSET__CTebDoFh__"